import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import frameSrc from './assets/Mockup.png';
import frameHeadSrc from './assets/Mockup-Head.png';
import Icon from "storybookComponents/Icon"
import "./index.css"

const useStyles = makeStyles((theme) => ({
  container: {
    width: 380,
    position: 'relative',
    "& img": {
      width: "100%",

    },
    "& .frameHead": {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 2
    },
    "& iframe": {
      border: "none",
      borderRadius: 33,
      overflow: "hidden",
      width: "100%"
    },

  },
  mainPreviewContainer: {
    display: "flex",
  },
  contentFrame: {
    top: 26,
    left: 29,
    right: 26,
    bottom: 28,
    background: "white",
    borderRadius: 32,
    // width: "calc(100% - 54px)",
    // height: "calc(100% - 63px)",
    zIndex: 1,
    position: "absolute",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  smsView: {
    alignItems: "flex-end",
    display: "flex"
  },
  smsViewIframe: {
    borderRadius: "0 !important;",
    marginBottom: 20
  },
  arrowIcon: {
    // padding: 10,
    width: 80,
    //height: "100vh",
    cursor: "pointer",
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    paddingTop: 400,
    "&&:hover": {
      background: "#f2fbfe",
      color: "#26BBED !important"
    },
    "&&icon": {
      fontSize: "40px !important"
    }
  },
  arrowIconNull: {
    width: 40,
    padding: 10,
    //height: "100vh",
    display: "flex",
    alignItems: "center",
  }

}));

const MobilePreview = ({
  html,
  smsView
}) => {
  const [index, setIndex] = React.useState(0);
  const [extrenalLink, setExternalLinkFlag] = React.useState(false);

  React.useEffect(() => {
    const frame = document.getElementById("Iframe");
    if (!frame) return;

    // Adjusting the iframe height onload event 
    frame.onload = function ()
    // function execute while load the iframe 
    {
      // set the height of the iframe as  
      // the height of the iframe content 
      try {
        frame.style.height =
          (frame.contentWindow.document.body.scrollHeight + (smsView ? 20 : 0)) + 'px';
      }
      catch (error) {
        frame.style.minHeight = "1450px";
        frame.style.height = "auto";
        setExternalLinkFlag(true)
        //frame.style.overflow = "auto";
      }


      // set the width of the iframe as the  
      // width of the iframe content 
      // frame.style.width =
      //   frame.contentWindow.document.body.scrollWidth + 'px';

    }
  }, [1])

  const prevView = () => {
    setIndex(index - 1);
  }

  const nextView = () => {
    setIndex(index + 1);
  }

  const classes = useStyles();
  return (
    <div className={classes.mainPreviewContainer}>
      {
        Array.isArray(html) ? index > 0 ?
          <div className={classes.arrowIcon} onClick={prevView}>
            <Icon type="icon-left-arrow" />
          </div> :
          <div className={classes.arrowIconNull}>
          </div> : null
      }
      <div className={classes.container}>
        <img src={frameSrc} alt="frame" />
        <img src={frameHeadSrc} className="frameHead" alt="frameHeadSrc" />
        <div id="hyly-preview-mobile" className={`${classes.contentFrame} ${!extrenalLink && smsView && classes.smsView}`}>
          <iframe id="Iframe" srcDoc={Array.isArray(html) ? html[index] : html} title="content" scrolling="no" className={`${smsView ? classes.smsViewIframe : ""}`} />
        </div>
      </div>
      {
        Array.isArray(html) ? index < html.length - 1 ?
          <div className={classes.arrowIcon} onClick={nextView}>
            <Icon type="icon-right-arrow" />
          </div> :
          <div className={classes.arrowIconNull}>
          </div>
          : null
      }
    </div>
  );
}

MobilePreview.propTypes = {
  html: PropTypes.string,
};

MobilePreview.defaultProps = {
  html: '<div>Hello World</div>',
};

export default MobilePreview;
